module.exports = __webpack_public_path__ + "img/zoom-out.72d58829.svg";